// extracted by mini-css-extract-plugin
export default {"cls1":"S1Tx6TrN8K5ZDJ4UvvxY","cls2":"eqojUiBHZecMmRsj7EyU S1Tx6TrN8K5ZDJ4UvvxY"};